import axios from "axios";
import { baseUrl, config, requestID } from "../common/utils";

export const getTaxes = async (payload?: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Taxes/getTaxes",
            data,
            config
        );
        console.log("taxes", response);
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const createTax = async (payload: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + "Geacloud_Taxes/createTax",
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const updateTax = async (payload: any) => {
    const data = {
        requestID: requestID(),
        ...payload
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Taxes/updateTax`,
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const deleteTax = async (id: string) => {
    const data = {
        requestID: requestID(),
        geacloud_taxes_id:id
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Taxes/deleteTax`,
            data,
            config
        );
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};

export const getTax = async (id: string) => {
    const data = {
        requestID: requestID(),
        geacloud_taxes_id: id
    };
    try {
        const response = await axios.post(
            baseUrl() + `Geacloud_Taxes/getTaxById`,
            data,
            config
        );
        
        console.log({ response });
        return response.data;
    } catch (error: any) {
        return error;
    }
};
